<template>
  <v-card flat class="futuristic-card">
    <div class="card-header">
      <h4 class="earth-color">PENDING PARTNER BOOKINGS</h4>
      <div class="title-decoration"></div>
    </div>
    <v-container>
      <v-layout row wrap>
        <v-flex lg12 md12 sm12 xs12>
          <v-layout row wrap>
            <v-flex lg4 md4 sm12 xs12>
              <v-container>
                <v-dialog
                  ref="dialog"
                  persistent
                  v-model="modal1"
                  lazy
                  full-width
                  width="290px"
                  :return-value.sync="calendar.start_date"
                >
                  <v-text-field
                    slot="activator"
                    label="Start Date"
                    v-model="calendar.start_date"
                    readonly
                    class="futuristic-input"
                  ></v-text-field>
                  <v-date-picker v-model="calendar.start_date" scrollable>
                    <v-spacer></v-spacer>
                    <v-btn
                      depressed
                      flat
                      color="#ef5350"
                      class="futuristic-btn"
                      @click="modal1 = false"
                      >Cancel</v-btn
                    >
                    <v-btn
                      depressed
                      flat
                      color="#587e27"
                      class="futuristic-btn"
                      @click="$refs.dialog.save(calendar.start_date)"
                      >OK</v-btn
                    >
                  </v-date-picker>
                </v-dialog>
              </v-container>
            </v-flex>
            <v-flex lg4 md4 sm12 xs12>
              <v-container>
                <v-dialog
                  ref="dialog1"
                  persistent
                  v-model="modal2"
                  lazy
                  full-width
                  width="290px"
                  :return-value.sync="calendar.end_date"
                >
                  <v-text-field
                    slot="activator"
                    label="End Date"
                    v-model="calendar.end_date"
                    readonly
                    class="futuristic-input"
                  ></v-text-field>
                  <v-date-picker
                    :min="calendar.start_date"
                    v-model="calendar.end_date"
                    scrollable
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                      depressed
                      flat
                      color="#ef5350"
                      class="futuristic-btn"
                      @click="modal2 = false"
                      >Cancel</v-btn
                    >
                    <v-btn
                      depressed
                      flat
                      color="#587e27"
                      class="futuristic-btn"
                      @click="$refs.dialog1.save(calendar.end_date)"
                      >OK</v-btn
                    >
                  </v-date-picker>
                </v-dialog>
              </v-container>
            </v-flex>
            <v-flex lg4 md4 sm12 xs12>
              <br />
              <v-btn
                depressed
                color="#587e27"
                class="futuristic-btn action-btn"
                @click="getData()"
                block
                :loading="this.$store.state.LoadingStore.loading"
                >Get Selected CHECKING IN Dates</v-btn
              >
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
    <v-data-table
      :headers="columns"
      :items="pendingPartnerBookings"
      :search="search"
      :rows-per-page-items="[10, 25, { text: 'All', value: -1 }]"
      :disable-initial-sort="true"
      :loading="$loadingTrue"
      class="futuristic-table"
    >
      <v-progress-linear
        slot="progress"
        color="#587e27"
        indeterminate
        height="3"
      ></v-progress-linear>
      <template slot="items" slot-scope="props">
        <td class="fancy">
          <router-link
            :to="{
              name: 'Booking',
              params: { booking_id: props.item.booking_public_id },
            }"
            ><a class="text-dark"
              ><u>{{ props.item.booking_ref_code }}</u></a
            ></router-link
          >
        </td>
        <td class="fancy">
          {{ formated_date(props.item.booking_check_in_date) }}
        </td>
        <td class="fancy">
          {{ formated_date(props.item.booking_check_out_date) }}
        </td>
        <td class="fancy">{{ props.item.guest_total }}</td>
        <td class="fancy">{{ props.item.booking_done_by }}</td>
        <td class="fancy" :style="props.item.booking_color">
          {{ props.item.booking_status }}
        </td>
        <td class="fancy">
          <v-btn
            depressed
            small
            color="#587e27"
            class="futuristic-btn"
            @click="openBooking(props.item.booking_public_id)"
            >View Booking</v-btn
          >
        </td>
      </template>
      <v-alert slot="no-results" :value="true" color="error" icon="warning" class="futuristic-alert">
        Your search for "{{ search }}" found no results.
      </v-alert>
    </v-data-table>
  </v-card>
</template>

<script>
export default {
  name: "pending-partner-bookings",
  data() {
    return {
      search: "",
      modal1: false,
      modal2: false,
      columns: [
        {
          text: "Ref",
          name: "booking_ref_code",
          class: 'table-header'
        },
        {
          text: "Check In",
          name: "check_in",
          class: 'table-header'
        },
        {
          text: "Check Out",
          name: "check_out",
          class: 'table-header'
        },
        {
          text: "Number of Guests",
          name: "guest_total",
          class: 'table-header'
        },
        {
          text: "Booking By",
          name: "booking_status",
          class: 'table-header'
        },
        {
          text: "Booking Status",
          name: "booking_status",
          class: 'table-header'
        },
        {
          text: "Action",
          value: "",
          class: 'table-header'
        },
      ],
      today: this.$moment.now(),
      calendar: {
        start_date: this.$moment(this.today).format("YYYY-MM-DD"),
        end_date: this.$moment(this.today).add(5, "days").format("YYYY-MM-DD"),
      },
    };
  },
  created() {
    this.$store.dispatch("get_pending_partner_bookings", this.calendar);
  },
  methods: {
    openBooking: function (publicId) {
      this.$router.push({
        name: "Booking",
        params: {
          booking_id: publicId,
        },
      });
    },
    getData: function () {
      this.$store.dispatch("loading_true");
      this.$store.dispatch("get_pending_partner_bookings", this.calendar);
    },
  },
};
</script>

<style scoped>
.futuristic-card {
  border-radius: 8px;
  background: #ffffff;
  transition: all 0.3s ease;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.futuristic-card:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.card-header {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 20px;
}

.earth-color {
  color: #587e27;
  font-weight: 600;
  margin: 0;
}

.title-decoration {
  height: 4px;
  background: linear-gradient(90deg, #587e27, transparent);
  margin-bottom: 16px;
  width: 100px;
}

.futuristic-input >>> .v-input__slot {
  border-radius: 8px;
  background: #f5f7fa;
}

.futuristic-btn {
  border-radius: 8px;
  text-transform: none;
  font-weight: 500;
  transition: all 0.2s ease;
  color: white;
}

.futuristic-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.action-btn {
  margin: 4px;
}

.futuristic-table >>> thead tr th {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa) !important;
  color: #587e27 !important;
  font-weight: 600;
  font-size: 14px;
}

.futuristic-table >>> tbody tr:nth-of-type(even) {
  background-color: #f9f9f9;
}

.futuristic-table >>> tbody tr:hover {
  background-color: #f0f4f8 !important;
}

.futuristic-alert {
  border-radius: 8px;
  margin: 16px;
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .card-header {
    padding: 12px;
  }
}

@media (max-width: 600px) {
  .card-header {
    padding: 8px;
  }
}
</style>